// @flow

import * as React from 'react'
import type { Rules } from 'frame/core/formValidate'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'
import { setFormValidateRules } from '../../redux/basic'

type Props = {
  rules: Rules,
  field?: string,
  base64Field?: string,
  fileField?: string,
  formId: string,
  id: string
};

export default function (WrappedComponent: React.ComponentType<*>) {
  return class FormValidateRules extends React.PureComponent<*> {
    static actions = appendPropsActions(WrappedComponent);
    static schema = appendPropsSchema(WrappedComponent);

    wrappedComponent: ?React.Component<*>;

    componentWillUpdate (nextProps: Props) {
      this.setValidateRules(nextProps)
    }

    componentDidMount () {
      this.setValidateRules(this.props)
    }

    setValidateRules = (props: Props) => {
      const { rules, field, base64Field, fileField, formId, id } = props
      const filedName = field || base64Field || fileField
      if (filedName && rules) {
        setFormValidateRules(formId, id, { [filedName]: rules })
      }
    };

    componentWillUnmount () {
      const { formId, id } = this.props
      setFormValidateRules(formId, id, {})
    }

    render () {
      return (
        <WrappedComponent
          ref={ref => {
            if (ref) {
              this.wrappedComponent = ref
            }
          }}
          {...this.props}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/formValidateRules.js